import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import './index.css';
import App from "./App";

// Desabilitar console.log em todos os ambientes
console.log = () => {};
console.debug = () => {};
console.info = () => {};
// Mantém console.warn e console.error para mensagens importantes

const root = createRoot(document.querySelector("#root"));

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
